export default __webpack_public_path__ + "static/media/widget-error.1d9718f7.svg";